<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label>
      <b>{{ label }}</b>
    </v-label>
    <s-select-generic
      class="text"
      itemvalue="AsuID"
      :disabled="disabled"
      :value="value"
      id="AsuID"
      itemtext="Description"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      autocomplete
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/SubstancesService.js";

export default {
  name: "SelectSubstances",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    asuID: {
      type: Number,
      default: 0,
    },
    typeSubstances: {
      type: [Number, String],
      default: null,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    autocomplete: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    typeSubstances: {
      handler() {
        this.loadConfig();
      },
    },
  },
  methods: {
    input(val) {
      const parsedVal =
        val !== null && val !== undefined && val !== 0 && val !== ""
          ? val
          : null;
      this.$emit("input", parsedVal);
    },
    loadConfig() {
      const typeVal =
        this.typeSubstances !== null &&
        this.typeSubstances !== undefined &&
        this.typeSubstances !== ""
          ? Number(this.typeSubstances)
          : null;

      const params = {
        search: "",
        requestID: this.$fun.getUserID(),
        TypeSubstances: typeVal,
      };

      this.config = {
        url: _sService.getUrlList(),
        title: this.label,
        params: params,
      };
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),
  created() {
    this.loadConfig();
  },
};
</script>
